import React, { FC } from 'react';

interface ComponentsProps {}

const Components: FC<ComponentsProps> = () => (
<>
<div id="kt_header_mobile" className="header-mobile align-items-center header-mobile-fixed">
    <a href="pages/index.html">
      <img alt="Logo" src="media/brands/logo.svg" />
    </a>

    <div className="d-flex align-items-center">
      <div className="topbar-item">
        <div className="dropdown">
          <div className="topbar-item btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary" data-toggle="dropdown" data-offset="10px,0px">
            <i className="ri-notification-2-fill text-dark-50">
              <div className="notify-number"></div>
            </i>
          </div>
          <div className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg dropdown-height-noti">
            <ul className="list-none">
              <li className="noti-item">
                <a href="">Content</a>
              </li>
              <li className="noti-item">
                <a href="">Content</a>
              </li>
              <li className="noti-item">
                <a href="">Content</a>
              </li>
              <li className="noti-item">
                <a href="">Content</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button className="btn p-0 brand-toggle burger-icon-left" id="kt_aside_mobile_toggle">
        <div className="con">
          <div className="bar arrow-top"></div>
          <div className="bar arrow-middle"></div>
          <div className="bar arrow-bottom"></div>
        </div>
      </button>
      <div className="dropdown">
        <a className="btn btn-hover-text-primary p-0 ml-2" data-toggle="dropdown">
          {/* <div className="avatar-image" style="background-image: url(media/default/avatar.svg)"></div> */}
        </a>
        <div className="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-md dropdown-menu-right">
          <ul className="navi navi-hover py-4">
            <li className="navi-item">
              <a href="pages/profile/1-doi-mat-khau.html" className="navi-link">
                <img src="media/icons-color/subdefault/default/key.svg" alt="" className="navi-icon"/>
                <span className="navi-text">Đổi mật khẩu</span>
              </a>
            </li>
            <li className="navi-item">
              <a href="pages/login/1-login.html" className="navi-link">
                <img src="media/icons-color/subdefault/default/logout.svg" alt="" className="navi-icon" />
                <span className="navi-text">Đăng xuất</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div id="kt_header" className="header header-fixed">
    <div className="d-flex align-items-stretch header-inner">
      <div className="brand flex-column-auto" id="kt_brand">
        <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
          <img src="media/icons-color/primary/default/burger-2.svg" alt="" />
        </button>

        <a href="pages/index.html" className="brand-logo">
          <img alt="Logo" src="media/brands/logo.svg" />
        </a>
      </div>
      <div className="w-100 justify-content-between d-flex">
        <div className="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
          <div id="kt_header_menu" className="align-items-center header-menu header-menu-mobile header-menu-layout-default">
            <div className="pl-32 h4 text-primary">Hệ thống tracking tổng hợp VNEvents</div>
          </div>
        </div>
        <div className="topbar">
          <div className="topbar-item">
            <div className="dropdown">
              <div className="topbar-item btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary" data-toggle="dropdown" data-offset="10px,0px">
                <i className="ri-notification-2-fill text-dark-50">
                  <div className="notify-number"></div>
                </i>
              </div>
              <div className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg dropdown-height-noti">
                <ul className="list-none">
                  <li className="noti-item">
                    <a href="">Content</a>
                  </li>
                  <li className="noti-item">
                    <a href="">Content</a>
                  </li>
                  <li className="noti-item">
                    <a href="">Content</a>
                  </li>
                  <li className="noti-item">
                    <a href="">Content</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="dropdown avatar-dropdown">
            <div className="topbar-item" data-toggle="dropdown" data-offset="10px,0px">
              <div className="btn btn-icon w-auto d-flex align-items-center btn-lg px-2">
                <div className="avatar-text">
                  <div className="h5 text-dark-50">
                    Xin chào!
                  </div>
                  <div className="p font-weight-500">Thuỷ</div>
                </div>
                {/* <div className="avatar-image" style="background-image: url(media/default/avatar.svg)"></div> */}
                <div className="avatar-arrow">
                  <img src="media/icons-color/subdefault/default/carret-down.svg" alt="" />
                </div>
              </div>
            </div>
            <div className="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-md dropdown-menu-right">
              <ul className="navi navi-hover py-4">
                <li className="navi-item">
                  <a href="pages/profile/1-doi-mat-khau.html" className="navi-link">
                    <img src="media/icons-color/subdefault/default/key.svg" alt="" className="navi-icon"/>
                    <span className="navi-text">Đổi mật khẩu</span>
                  </a>
                </li>
                <li className="navi-item">
                  <a href="pages/login/1-login.html" className="navi-link">
                    <img src="media/icons-color/subdefault/default/logout.svg" alt="" className="navi-icon" />
                    <span className="navi-text">Đăng xuất</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="d-flex flex-column flex-root">
    <div className="d-flex flex-row flex-column-fluid page">
      <div className="aside aside-left aside-fixed d-flex flex-column flex-row-auto" id="kt_aside">
        <div className="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
          <div id="kt_aside_menu" className="aside-menu my-4" data-menu-vertical="1" data-menu-scroll="1" data-menu-dropdown-timeout="500">
            <ul className="menu-nav">
              <li className="menu-item center menu-item-active" aria-haspopup="true">
                <a href="pages/components.html" className="menu-link">
                  <div className="menu-icon"><img src="media/icons/metronic/puzzle.svg" alt="" className=""/></div>
                  <span className="menu-text">Component</span>
                </a>
              </li>
              <li className="menu-item center" aria-haspopup="true">
                <a href="pages/" className="menu-link">
                  <div className="menu-icon"><img src="media/icons/metronic/layout-4-block.svg" alt="" className=""/></div>
                  <span className="menu-text">Màn hình chính</span>
                </a>
              </li>
              <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                <a href="javascript:;" className="menu-link menu-toggle">
                  <div className="menu-icon"><img src="media/icons/metronic/cod007.svg" alt="" className="" /></div>
                  <span className="menu-text">Quản trị hệ thống</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className="menu-submenu">
                  <i className="menu-arrow"></i>
                  <ul className="menu-subnav">
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/quan-tri-he-thong/quan-ly-tai-khoan/1-quan-ly-tai-khoan-danh-sach.html" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý tài khoản</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý phân quyền</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                <a href="javascript:;" className="menu-link menu-toggle"> 
                  <div className="menu-icon"><img src="media/icons/metronic/breifcase.svg" alt="" className="" /></div>
                  <span className="menu-text">Quản lý khai báo</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className="menu-submenu">
                  <i className="menu-arrow"></i>
                  <ul className="menu-subnav">
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/quan-ly-khai-bao/quan-ly-event/1-quan-ly-event-danh-sach.html" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý event</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/quan-ly-khai-bao/quan-ly-funnel/1-quan-ly-funnel-danh-sach.html" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý funnel</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/quan-ly-khai-bao/quan-ly-kenh-quang-cao/1-quan-ly-kenh-quang-cao-danh-sach.html" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý kênh quảng cáo</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý dịch vụ liên kết</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý link quảng cáo</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý đối tác</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/quan-ly-khai-bao/quan-ly-ung-dung/1-quan-ly-ung-dung-danh-sach.html" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Quản lý ứng dụng</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                <a href="javascript:;" className="menu-link menu-toggle">
                  <div className="menu-icon"><img src="media/icons/metronic/chartbar1.svg" alt="" className="" /></div>
                  <span className="menu-text">Báo cáo</span>
                  <i className="menu-arrow"></i>
                </a>
                <div className="menu-submenu">
                  <i className="menu-arrow"></i>
                  <ul className="menu-subnav">
                    <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                      <a href="javascript:;" className="menu-link menu-toggle">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Báo cáo CES</span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className="menu-submenu">
                        <i className="menu-arrow"></i>
                        <ul className="menu-subnav">
                          <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                            <a href="javascript:;" className="menu-link menu-toggle">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo Marketing</span>
                              <i className="menu-arrow"></i>
                            </a>
                            <div className="menu-submenu">
                              <i className="menu-arrow"></i>
                              <ul className="menu-subnav">
                                <li className="menu-item center" aria-haspopup="true">
                                  <a href="pages/bao-cao/bao-cao-ces/bao-cao-marketing/1-bao-cao-marketing-ve-tau.html" className="menu-link">
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span></span>
                                    </i>
                                    <span className="menu-text">Vé tàu</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                            <a href="javascript:;" className="menu-link menu-toggle">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo doanh thu</span>
                              <i className="menu-arrow"></i>
                            </a>
                            <div className="menu-submenu">
                              <i className="menu-arrow"></i>
                              <ul className="menu-subnav">
                                <li className="menu-item center" aria-haspopup="true">
                                  <a href="pages/bao-cao/bao-cao-ces/bao-cao-doanh-thu/1-bao-cao-doanh-thu-ve-tau.html" className="menu-link">
                                    <i className="menu-bullet menu-bullet-dot">
                                      <span></span>
                                    </i>
                                    <span className="menu-text">Vé tàu</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/bao-cao/bao-cao-tong-hop-event/1-bao-cao-tong-hop-event.html" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Báo cáo tổng hợp event</span>
                      </a>
                    </li>
                    <li className="menu-item center" aria-haspopup="true">
                      <a href="pages/" className="menu-link">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Báo cáo sử dụng deeplink</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-submenu" aria-haspopup="true" data-menu-toggle="hover">
                      <a href="javascript:;" className="menu-link menu-toggle">
                        <i className="menu-bullet menu-bullet-dot">
                          <span></span>
                        </i>
                        <span className="menu-text">Báo cáo thống kê</span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className="menu-submenu">
                        <i className="menu-arrow"></i>
                        <ul className="menu-subnav">
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo Marketing</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/bao-cao/bao-cao-thong-ke/bao-cao-nguoi-dung-cai-dat-ung-dung/1-1-bao-cao-nguoi-dung-cai-dat-ung-dung.html" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo người dùng cài đặt ứng dụng</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo người dùng chuyển đổi tiềm năng</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo người dùng chuyển đổi mới</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo người dùng ngừng sử dụng ứng dụng</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/bao-cao/bao-cao-thong-ke/bao-cao-nguoi-dung-su-dung-thuong-xuyen/1-1-bao-cao-nguoi-dung-su-dung-thuong-xuyen.html" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo người dùng sử dụng thường xuyên</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo tỷ lệ người dùng</span>
                            </a>
                          </li>
                          <li className="menu-item center" aria-haspopup="true">
                            <a href="pages/" className="menu-link">
                              <i className="menu-bullet menu-bullet-dot">
                                <span></span>
                              </i>
                              <span className="menu-text">Báo cáo tỷ lệ bounce rate của ứng dụng</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
        <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div className="d-flex flex-column-fluid">
            <div className="container">
              <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 h5">
                <li className="breadcrumb-item">
                  <a className="text-dark" href="pages/index.html">
                    <i className="ri-home-4-fill text-dark pr-4 fz-h4"></i>
                    <span className="txt">Trang chủ</span>
                  </a>
                </li>
                <li className="breadcrumb-item text-muted">
                  <a className="text-dark-50" href="pages/index.html">
                    <span className="txt">Home</span>
                  </a>
                </li>
                <li className="breadcrumb-item text-muted breadcrumbs-item--active">
                  <a className="text-dark-50">
                    <span className="txt">Component</span>
                  </a>
                </li>
              </ul>
   
              <div className="row">
                <div className="col-12">
                  
                  <div className="card card-border card-custom gutter-b example example-compact">
                    
                    <form className="form" id="kt_form_1">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Form validation
                        </div>
                        <div className="list-mb16 list-crop">
                          <div className="section">
                            <div className="row list-mb16 list-crop">
                              <div className="col-xl-3 col-lg-4 col-sm-6">
                                <div className="form-group">
                                  <label>
                                    Checkbox
                                  </label>
                                  <div className="checkbox-inline">
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkboxes"/>
                                      <span></span>checkbox 1
                                    </label>
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkboxes"/>
                                      <span></span>checkbox 2
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-xl-3 col-lg-4 col-sm-6">
                                <div className="form-group">
                                  <label>
                                    Radio
                                  </label>
                                  <div className="radio-inline">
                                    <label className="radio">
                                      <input type="radio" name="radios" />
                                      <span></span>radio 1
                                    </label>
                                    <label className="radio">
                                      <input type="radio" name="radios" />
                                      <span></span>radio 2
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="row list-mb16 list-crop">
                              <div className="col-xl-3 col-lg-4 col-sm-6">
                                <div className="form-group">
                                  <label>
                                    <span className="text-danger">*</span>
                                    Input
                                  </label>
                                  <input type="email" className="form-control" placeholder="Nhập input" name="email"/>
                                </div>
                              </div>
                              <div className="col-xl-3 col-lg-4 col-sm-6">
                                <div className="form-group">
                                  <label>
                                    <span className="text-danger">*</span>
                                    Select
                                  </label>
                                  <select className="form-control selectpicker" title="Chọn"  name="select" data-size="5">
                                    <option>
                                      Tất cả
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="row list-mb16 list-crop">
                              <div className="col-xl-5 col-md-6">
                                <div className="form-group row row-16">
                                  <label className="col-form-label col-sm-5">
                                    Input
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <input type="email" className="form-control" placeholder="Nhập input" name="email" />
                                  </div>
                                </div>
                              </div>
                              <div className="offset-xl-1 col-xl-5 col-md-6">
                                <div className="form-group row row-16">
                                  <label className="col-form-label col-sm-5">
                                    Select
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <select className="form-control selectpicker" title="Chọn" name="select" data-size="5">
                                      <option>
                                        Tất cả
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="row row-16">
                          <div className="col-auto">
                            <button type="submit" name="submitButton" className="btn btn-primary">Validate</button>
                          </div>
                          <div className="col-auto">
                            <button type="reset" className="btn btn-secondary">Cancel</button>
                          </div>
                        </div>
                      </div>
                    </form>
                    
                  </div>
                  
                </div>
                <div className="col-12">
                  
                  <div className="card card-border card-custom gutter-b example example-compact">
                    
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Input
                          vertical
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Input
                              </label>
                              <input type="text" className="form-control" placeholder="Nhập input"/>
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Input with note
                              </label>
                              <input type="text" className="form-control" placeholder="Nhập input with note" />
                              <span className="form-text">Note example</span>
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Input with note
                              </label>
                              <textarea className="form-control textarea-autosize" placeholder="Input with note" rows={2}></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-12">
                  
                  <div className="card card-border card-custom gutter-b example example-compact">
                    
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Select
                          vertical
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Select
                              </label>
                              <select className="form-control selectpicker" title="Chọn" data-size="5">
                                <option>
                                  Tất cả
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Select search
                              </label>
                              <select className="form-control selectpicker" title="Chọn" data-size="5" data-live-search="true" data-live-search-normalize="true">
                                <option>
                                  Alaska Alaska Alaska Alaska Alaska Alaska Alaska Alaska Alaska Alaska
                                </option>
                                <option>
                                  Hawaii
                                </option>
                                <option>
                                  California
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Select Multiple
                              </label>
                              <select className="form-control selectpicker" title="Chọn" data-size="5" data-live-search="true" data-live-search-normalize="true" multiple={true} data-selected-text-format="count > 2" data-actions-box="true">
                                <option>
                                  Alaska
                                </option>
                                <option>
                                  Hawaii
                                </option>
                                <option>
                                  California
                                </option>
                                <option>
                                  Washington
                                </option>
                                <option>
                                  Arizona
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-12">
                  
                  <div className="card card-border card-custom gutter-b example example-compact">
                    
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Datepicker
                          vertical
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Single
                              </label>
                              <input type="text" className="form-control datepicker datepicker-date" placeholder="dd/mm/yyyy - dd/mm/yyyy" data-opens="left" data-single-date-picker="true" />
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Range
                              </label>
                              <input type="text" className="form-control datepicker datepicker-date" placeholder="dd/mm/yyyy - dd/mm/yyyy" data-opens="left" />
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Range Time
                              </label>
                              <input type="text" className="form-control datepicker datepicker-date-time" placeholder="dd/mm/yyyy - dd/mm/yyyy" data-opens="left" />
                            </div>
                          </div>
                          <div className="col-xl-3 col-lg-4 col-sm-6">
                            <div className="form-group">
                              <label>
                                Timepicker
                              </label>
                              <input type="text" className="form-control timepicker" placeholder="Nhập timepicker" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  
                  <div className="card card-border card-custom gutter-b example example-compact">
                    
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Input
                          horizontal
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-5 col-md-6">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Input
                              </label>
                              <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Nhập input"/>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6 offset-xl-1">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Input with note
                              </label>
                              <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Nhập input with note" />
                                <span className="form-text">Note example</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Input with note
                              </label>
                              <div className="col-sm-7">
                                <textarea className="form-control textarea-autosize" placeholder="Input with note" rows={2}></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Select
                          horizontal
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-5 col-md-6">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Select
                              </label>
                              <div className="col-sm-7">
                                <select className="form-control selectpicker" title="Chọn" data-size="5">
                                  <option>
                                    Tất cả
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6 offset-xl-1">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Select search
                              </label>
                              <div className="col-sm-7">
                                <select className="form-control selectpicker" title="Chọn" data-size="5" data-live-search="true" data-live-search-normalize="true">
                                  <option>
                                    Alaska Alaska Alaska Alaska Alaska Alaska Alaska Alaska Alaska Alaska
                                  </option>
                                  <option>
                                    Hawaii
                                  </option>
                                  <option>
                                    California
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Select Multiple
                              </label>
                              <div className="col-sm-7">
                                <select className="form-control selectpicker" title="Chọn" data-size="5" data-live-search="true" data-live-search-normalize="true" 
                                multiple={true} data-selected-text-format="count > 2" data-actions-box="true">
                                  <option>
                                    Alaska
                                  </option>
                                  <option>
                                    Hawaii
                                  </option>
                                  <option>
                                    California
                                  </option>
                                  <option>
                                    Washington
                                  </option>
                                  <option>
                                    Arizona
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Datepicker
                          horizontal
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-5 col-md-6">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Single
                              </label>
                              <div className="col-sm-7">
                                <input type="text" className="form-control datepicker datepicker-date" placeholder="dd/mm/yyyy - dd/mm/yyyy" data-opens="left" data-single-date-picker="true" />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6 offset-xl-1">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Range
                              </label>
                              <div className="col-sm-7">
                                <input type="text" className="form-control datepicker datepicker-date" placeholder="dd/mm/yyyy - dd/mm/yyyy" data-opens="left" />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Range Time
                              </label>
                              <div className="col-sm-7">
                                <input type="text" className="form-control datepicker datepicker-date-time" placeholder="dd/mm/yyyy - dd/mm/yyyy" data-opens="left" />
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-5 col-md-6 offset-xl-1">
                            <div className="form-group row row-16">
                              <label className="col-form-label col-sm-5">
                                Timepicker
                              </label>
                              <div className="col-sm-7">
                                <input type="text" className="form-control timepicker" placeholder="Nhập timepicker" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Form Labels
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-5 col-md-6">
                            <div className="form">
                              <div className="row list-mt16 list-crop">
                              </div>
                            </div>
                          </div>
                          <div className="offset-xl-1 col-xl-5 col-md-6">
                            <div className="form">
                              <div className="row list-mt16 list-crop">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Checkbox - Radio
                        </div>
                        <div className="list-mb16 list-crop">
                          <div className="section">
                            <div className="row list-mb16 list-crop">
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-group">
                                  <div className="checkbox-list">
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkbox1" />
                                      <span></span>Checkbox
                                    </label>
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkbox1" disabled />
                                      <span></span>Checkbox Disabled
                                    </label>
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkbox1" checked />
                                      <span></span>Checkbox checked
                                    </label>
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkbox1" checked disabled />
                                      <span></span>Checkbox checked Disabled
                                    </label>
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkbox1" disabled />
                                      <span></span>Checkbox Readonly
                                    </label>
                                    <label className="checkbox">
                                      <input type="checkbox" name="checkbox1" checked disabled />
                                      <span></span>Checkbox checked Readonly
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-sm-6">
                                <div className="form-group">
                                  <div className="radio-list">
                                    <label className="radio">
                                      <input type="radio" name="radio1" />
                                      <span></span>radio
                                    </label>
                                    <label className="radio">
                                      <input type="radio" name="radio2" disabled />
                                      <span></span>radio Disabled
                                    </label>
                                    <label className="radio">
                                      <input type="radio" name="radio3" checked />
                                      <span></span>radio checked
                                    </label>
                                    <label className="radio">
                                      <input type="radio" name="radio4" checked disabled />
                                      <span></span>radio checked Disabled
                                    </label>
                                    <label className="radio">
                                      <input type="radio" name="radio5" disabled />
                                      <span></span>radio Readonly
                                    </label>
                                    <label className="radio">
                                      <input type="radio" name="radio6" checked disabled />
                                      <span></span>Checkbox checked Readonly
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Form Labels
                        </div>
                        <div className="row list-mb16 list-crop">
                          <div className="col-xl-5 col-md-6">
                            <div className="form">
                              <div className="row list-mt16 list-crop">
                              </div>
                            </div>
                          </div>
                          <div className="offset-xl-1 col-xl-5 col-md-6">
                            <div className="form">
                              <div className="row list-mt16 list-crop">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Buttons
                        </div>
                        <div className="list-mb16 list-crop">
                          <div className="section">
                            <div className="row row-16 list-mb16 list-crop">
                              <div className="col-auto">
                                <button className="btn btn-primary">
                                  Primary
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-light-primary">
                                  Light primary
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-secondary">
                                  Secondary
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-success">
                                  Success
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-light-primary">
                                  Button Icon
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-primary btn-large">
                                  Large
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="section">
                            <div className="row row-16 list-mb16 list-crop align-items-center">
                              <div className="col-auto">
                                <button className="btn btn-primary btn-sm">
                                  Small
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-primary">
                                  Default
                                </button>
                              </div>
                              <div className="col-auto">
                                <button className="btn btn-primary btn-lg">
                                  Large
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Labels
                        </div>
                        <div className="row row-10 list-mv8">
                          <div className="col-auto">
                            {/* <!-- util.labelStatus --> */}
                            <label className="label label-size-default label-light-success label-inline">Hoạt động</label>
                            {/* <!-- end util.labelStatus --> */}
                          </div>
                          <div className="col-auto">
                            {/* <!-- util.labelStatus --> */}
                            <label className="label label-size-default label-light-danger label-inline">Khoá</label>
                            {/* <!-- end util.labelStatus --> */}
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Modals Form
                        </div>
                        <div className="list-mb16 list-crop">
                          <div className="section">
                            <div className="row row-16 list-mb16 list-crop">
                              <div className="col-auto">
                                <a className="btn btn-primary" data-toggle="modal" data-target="#modalForm">
                                  Modal Form
                                </a>
                              </div>
                              <div className="col-auto">
                                <a className="btn btn-primary" data-toggle="modal" data-target="#modalAlert">
                                  Modal Alert
                                </a>
                              </div>
                              <div className="col-auto">
                                <a className="btn btn-primary" data-toggle="modal" data-target="#modalAlertError">
                                  Modal Alert Error
                                </a>
                              </div>
                              <div className="col-auto">
                                <a className="btn btn-primary" data-toggle="modal" data-target="#modalAlertSuccess">
                                  Modal Alert Success
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Toasts
                        </div>
                        <div className="list-mb16 list-crop">
                          <div className="section">
                            <div className="row row-16 list-mb16 list-crop">
                              <div className="col-auto">
                                <a className="btn btn-info" data-toast="toast" toast-target="#toastInfo">
                                  Info
                                </a>
                              </div>
                              <div className="col-auto">
                                <a className="btn btn-success" data-toast="toast" toast-target="#toastSuccess">
                                  Success
                                </a>
                              </div>
                              <div className="col-auto">
                                <a className="btn btn-warning" data-toast="toast" toast-target="#toastWarning">
                                  Warning
                                </a>
                              </div>
                              <div className="col-auto">
                                <a className="btn btn-danger" data-toast="toast" toast-target="#toastDanger">
                                  Danger
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
                <div className="col-12">
                  {/*  */}
                  <div className="card card-border card-custom gutter-b example example-compact">
                    {/*  */}
                    <form className="form">
                      <div className="card-body">
                        <div className="card-title h4 font-weight-500">
                          Table
                        </div>
                        {/* <!-- tables.table --> */}
                        <div className="table-wrap table-responsive-new">
                          <div className="table-top">
                            <div className="row align-items-center list-mb16 list-crop">
                              <div className="col">
                                Tổng số bản ghi:
                                <span className="font-weight-500 text-primary">1000</span>
                              </div>
                            </div>
                          </div>
                          <div className="table-wrap-inner">
                            <table className="table table-sticky-ult table-striped">
                              <thead>
                                <tr>
                                  <th>
                                    No.
                                  </th>
                                  <th className="sort sort-asc">
                                    Họ và tên
                                  </th>
                                  <th className="sort sort-desc">
                                    mã khách hàng
                                  </th>
                                  <th className="sort sort-no">
                                    loại kh
                                  </th>
                                  <th className="sort sort-no">
                                    số điện thoại
                                  </th>
                                  <th className="sort sort-no">
                                    kiểu khách hàng
                                  </th>
                                  <th className="sort sort-no">
                                    mã nhân viên
                                  </th>
                                  <th className="sort sort-no">
                                    trạng thái
                                  </th>
                                  <th className="sticky-ult">
                                    Thao tác
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    1
                                  </td>
                                  <td className="">
                                    Nông Thị Phù Dung
                                  </td>
                                  <td className="">
                                    8220-000576633
                                  </td>
                                  <td className="">
                                    100 - Individual
                                  </td>
                                  <td className="">
                                    0901171296
                                  </td>
                                  <td className="">
                                    Phổ thông
                                  </td>
                                  <td className="">
                                    12345678
                                  </td>
                                  <td className="">
                                    {/* <!-- util.labelStatus --> */}
                                    <label className="label label-size-default label-light-success label-inline">Hoạt động</label>
                                    {/* <!-- end util.labelStatus --> */}
                                  </td>
                                  <td className="sticky-ult">
                                    {/* <!-- tables.tableUlt --> */}
                                    <div className="ult-wrap">
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Chỉnh sửa">
                                        <i className="ri-pencil-fill"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Thông tin">
                                        <i className="ri-information-fill"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Xoá">
                                        <i className="ri-delete-bin-fill text-danger"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Khoá">
                                        <i className="ri-lock-2-fill text-danger"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Cấp lại mật khẩu">
                                        <i className="ri-key-2-line"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Mở khoá">
                                        <i className="ri-lock-unlock-fill text-success"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Email">
                                        <i className="ri-mail-fill"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Email">
                                        <i className="ri-printer-fill"></i>
                                      </button>
                                    </div>
                                    {/* <!-- end tables.tableUlt --> */}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    2
                                  </td>
                                  <td className="">
                                    Tiêu Thị Phù Dung
                                  </td>
                                  <td className="">
                                    8220-000576633
                                  </td>
                                  <td className="">
                                    100 - Individual
                                  </td>
                                  <td className="">
                                    0901171296
                                  </td>
                                  <td className="">
                                    <span className="text-primary">VIP</span>
                                  </td>
                                  <td className="">
                                    —
                                  </td>
                                  <td className="">
                                    {/* <!-- util.labelStatus --> */}
                                    <label className="label label-size-default label-light-danger label-inline">Khoá</label>
                                    {/* <!-- end util.labelStatus --> */}
                                  </td>
                                  <td className="sticky-ult">
                                    {/* <!-- tables.tableUlt --> */}
                                    <div className="ult-wrap">
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Chỉnh sửa">
                                        <i className="ri-pencil-fill"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Thông tin">
                                        <i className="ri-information-fill"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Xoá">
                                        <i className="ri-delete-bin-fill text-danger"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Khoá">
                                        <i className="ri-lock-2-fill text-danger"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Cấp lại mật khẩu">
                                        <i className="ri-key-2-line"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Mở khoá">
                                        <i className="ri-lock-unlock-fill text-success"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Email">
                                        <i className="ri-mail-fill"></i>
                                      </button>
                                      <button className="btn btn-transaprent btn-icon btn-sm" data-tooltip="tooltip" title="Email">
                                        <i className="ri-printer-fill"></i>
                                      </button>
                                    </div>
                                    {/* <!-- end tables.tableUlt --> */}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="record-and-pagination">
                            <div className="row align-items-center list-mb16 list-crop justify-content-between">
                              <div className="col-md-auto">
                                {/* <!-- tables.record --> */}
                                <div className="record-number">
                                  <div className="row row-8 align-items-center">
                                    <div>
                                      Hiển thị
                                    </div>
                                    <div>
                                      <div className="form-group">
                                        <select className="form-control form-control-sm selectpicker" data-size="5">
                                          <option selected >
                                            5
                                          </option>
                                          <option>
                                            10
                                          </option>
                                          <option>
                                            15
                                          </option>
                                          <option>
                                            20
                                          </option>
                                          <option>
                                            25
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                    <div>
                                      bản ghi
                                    </div>
                                  </div>
                                </div>
                                {/* <!-- tables.record --> */}
                              </div>
                              <div className="col-md-auto">
                                {/* <!-- tables.pagination --> */}
                                <div className="pagination justify-content-center">
                                  <div className="d-flex flex-wrap py-2 mr-3">
                                    <a className="btn btn-icon btn-sm btn-secondary btn-disabled">
                                      <i className="ri-arrow-left-s-line"></i>
                                    </a>
                                    <a className="btn btn-icon btn-sm border-0 btn-hover-primary">1</a>
                                    <a className="btn btn-icon btn-sm border-0 btn-hover-primary active">2</a>
                                    <a className="btn btn-icon btn-sm border-0 btn-hover-primary">3</a>
                                    <a className="btn btn-icon btn-sm border-0 btn-hover-primary">...</a>
                                    <a className="btn btn-icon btn-sm border-0 btn-hover-primary">5</a>
                                    <a className="btn btn-icon btn-sm btn-secondary">
                                      <i className="ri-arrow-right-s-line"></i>
                                    </a>
                                  </div>
                                </div>
                                {/* <!-- tables.pagination --> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- end tables.table --> */}
                      </div>
                    </form>
                    {/*  */}
                  </div>
                  {/*  */}
                </div>
              </div>
              {/* <!--end::Dashboard--> */}
            </div>
            {/* <!--end::Container--> */}
          </div>
          {/* <!--end::Entry--> */}
        </div>
        {/* <!--end::Content--> */}
        <div id="footer"></div>
      </div>
      {/* <!--end::Wrapper--> */}
    </div>
    {/* <!--end::Page--> */}
  </div>
  <div id="kt_scrolltop" className="scrolltop">
    <i className="ri-arrow-up-s-line"></i>
  </div>

  <div className="modal fade modal-alert" id="modalSelectOrg"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title h2 b" id="exampleModalLabel">Lựa chọn tổ chức</h5>
        </div>
        <div className="modal-body">
          <div className="form list-mb24 list-crop">
            <div className="text-center text-dark-50 mb-20">
              Quý khách vui lòng lựa chọn thông tin tổ chức muốn truy cập
            </div>
            <div className="text-left">
              <div className="form-group">
                <label>
                  Tổ chức
                </label>
                <select className="form-control selectpicker" title="Chọn" data-size="5">
                  <option>
                    Công ty Cổ phần Công nghệ Giáo dục Tri thức số Việt Nam
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="row list-mb8 list-crop">
            <div className="col">
              <a className="btn btn-secondary btn-block" data-dismiss="modal">
                Đóng
              </a>
            </div>
            <div className="col">
              <a className="btn btn-primary btn-block" data-dismiss="modal">
                Tiếp tục
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div className="toast text-info" id="toastInfo" role="alert" aria-live="assertive" aria-atomic="true" >
    <div className="toast-body">
      <div className="row row-12">
        <div className="col flex-grow-1">
          <div className="toast-title">
            Toast Infro
          </div>
          <div className="toast-content text-dark">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed do eiusmod tempor
          </div>
        </div>
        <div className="col-auto">
          <button className="btn btn-transparent btn-icon btn-sm" data-dismiss="toast" aria-label="Close">
            <i className="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div className="toast text-success" id="toastSuccess" role="alert" aria-live="assertive" aria-atomic="true" >
    <div className="toast-body">
      <div className="row row-12">
        <div className="col flex-grow-1">
          <div className="toast-title">
            Toast Success
          </div>
          <div className="toast-content text-dark">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed do eiusmod tempor
          </div>
        </div>
        <div className="col-auto">
          <button className="btn btn-transparent btn-icon btn-sm" data-dismiss="toast" aria-label="Close">
            <i className="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div className="toast text-warning" id="toastWarning" role="alert" aria-live="assertive" aria-atomic="true" >
    <div className="toast-body">
      <div className="row row-12">
        <div className="col flex-grow-1">
          <div className="toast-title">
            Toast Warning
          </div>
          <div className="toast-content text-dark">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed do eiusmod tempor
          </div>
        </div>
        <div className="col-auto">
          <button className="btn btn-transparent btn-icon btn-sm" data-dismiss="toast" aria-label="Close">
            <i className="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div className="toast text-danger" id="toastDanger" role="alert" aria-live="assertive" aria-atomic="true" >
    <div className="toast-body">
      <div className="row row-12">
        <div className="col flex-grow-1">
          <div className="toast-title">
            Toast Danger
          </div>
          <div className="toast-content text-dark">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed do eiusmod tempor
          </div>
        </div>
        <div className="col-auto">
          <button className="btn btn-transparent btn-icon btn-sm" data-dismiss="toast" aria-label="Close">
            <i className="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <div className="modal fade" id="modalForm"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title h2 b" id="exampleModalLabel">Thông báo</h5>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <img src="media/icons-color/subdefault/default/24x24-close.svg" alt="" />
          </button>
        </div>
        <div className="modal-body">
          <div className="form list-mb24 list-crop">
            <div className="form-group">
              <label>
                Input
              </label>
              <input type="text" className="form-control" placeholder="Nhập input"/>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="row list-mb8 list-crop">
            <div className="col">
              <a className="btn btn-secondary btn-block btn-lg" data-dismiss="modal">
                Hủy bỏ
              </a>
            </div>
            <div className="col">
              <a className="btn btn-primary btn-block btn-lg" data-dismiss="modal">
                Tiếp tục
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="modal fade modal-alert" id="modalAlert"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title h2 b" id="exampleModalLabel">Thông báo</h5>
        </div>
        <div className="modal-body">
          content
        </div>
        <div className="modal-footer">
          <div className="row list-mb8 list-crop">
            <div className="col">
              <a className="btn btn-secondary btn-block btn-lg" data-dismiss="modal">
                Hủy bỏ
              </a>
            </div>
            <div className="col">
              <a className="btn btn-primary btn-block btn-lg" data-dismiss="modal">
                Tiếp tục
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="modal fade modal-alert" id="modalAlertError"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <div className="alert-ic">
            <i className="ri-error-warning-line text-danger"></i>
          </div>
          <h5 className="modal-title h2 b" id="exampleModalLabel">Thông báo</h5>
        </div>
        <div className="modal-body">
          Có lỗi xảy ra
        </div>
        <div className="modal-footer">
          <div className="row list-mb8 list-crop">
            <div className="col">
              <a className="btn btn-primary btn-block btn-lg" data-dismiss="modal">
                Đóng
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="modal fade modal-alert" id="modalAlertSuccess"  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <div className="alert-ic">
            <i className="ri-checkbox-circle-line text-success"></i>
          </div>
          <h5 className="modal-title h2 b" id="exampleModalLabel">Thông báo</h5>
        </div>
        <div className="modal-body">
          Thành công!
        </div>
        <div className="modal-footer">
          <div className="row list-mb8 list-crop">
            <div className="col">
              <a className="btn btn-primary btn-block btn-lg" data-dismiss="modal">
                Đóng
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>
);

export default Components;
